var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M17.071 15.349v1.062c0 .585-.478 1.063-1.062 1.063H1.134A1.066 1.066 0 0 1 .07 16.41V15.35c0-2.827 5.663-4.25 8.5-4.25 2.837 0 8.5 1.423 8.5 4.25zM4.321 4.724a4.249 4.249 0 0 1 4.25-4.25 4.249 4.249 0 0 1 4.25 4.25 4.249 4.249 0 0 1-4.25 4.25 4.249 4.249 0 0 1-4.25-4.25z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerProfile);
export default __webpack_public_path__ + "static/media/banner-profile.95b69eaed39cb737a550b6e5612e3026.svg";
export { ForwardRef as ReactComponent };